import axios, { AxiosRequestConfig } from 'axios'

import { IPlace } from '@/types/place'

export const getPlaces = async (phone: string): Promise<IPlace[]> => {
  const config: AxiosRequestConfig = {
    params: {
      phone,
    },
  }
  try {
    const response = await axios.get<IPlace[]>('place', config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.places.getPlaces')
  }
}
